import {
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  EventEmitter,
  HostListener,
  Inject,
  Input, OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID
} from '@angular/core';
import { DivisionsService } from '../../../../../../shared/modules/core/services/divisions.service';
import { Service } from '../service';
import { UserService } from '../../../../../../shared/modules/core/services/user.service';
import { HttpClient } from '@angular/common/http';
import { PriceService } from '../../../../../../shared/modules/core/services/price.service';
import { ToastrService } from 'ngx-toastr';
import { ServiceCustomization } from '../service-customization';
import { environment } from '../../../../../../../environments/environment';
import { isPlatformBrowser } from '@angular/common';
import { filter, take, takeUntil } from 'rxjs/operators';
import { BehaviorSubject, Subject } from 'rxjs';
import { NgxEzModalService } from '../../../../../../shared/modules/ngx-ez-modal/ngx-ez-modal.service';
import { LolCustomizationModalComponent } from '../../modals/lol-customization-modal/lol-customization-modal.component';
import { ValorantCustomizationModalComponent } from '../../modals/valorant-customization-modal/valorant-customization-modal.component';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { AverageCompletionService } from '../../../../../../shared/modules/core/services/average.completion.service';
import { services } from '../../services';
import { GoogleTagManagerService } from "angular-google-tag-manager";
import { cs2RanksToColor } from "../../../../../../shared/utils/cs2";

import { PositionSelectComponent } from '../../modals/position-select/position-select.component';
import { GameCharacterSelectComponent } from '../../modals/game-character-select/game-character-select.component';

@Component({
  selector: 'app-service-purchase',
  templateUrl: './service-purchase.component.html',
  styleUrls: ['./service-purchase.component.scss']
})
export class ServicePurchaseComponent implements OnInit, OnDestroy {
  @Input('service') set _service(service: Service) {
    if (this.service && service.server !== this.service.server) {
      this.selectedCreditAmount = 0;
    }

    this.service = service;
    this.title = this.generateTitle(service);
    this.serviceTitle = this.generateServiceTitle(service);
    this.availableDiscounts = this.getAvailableDiscounts(this.discounts, this.service, this.selectedDiscountId);

    if (!this.availableDiscounts.find(d => d.id === this.selectedDiscountId)) {
      this.selectedDiscountAmount = 0;
      this.selectedDiscountId = null;
      this.availableDiscounts = this.getAvailableDiscounts(this.discounts, this.service, this.selectedDiscountId);
    }

    this.isDuoCookie = this.isDuo();

    if (this.isDuoCookie) {
      if (
        (this.service.service === 'masteries' && this.service.game === 'lol') ||
        (this.service.service !== 'normalgames' && (this.service.game === 'tft' && this.service.queue !== 'doubleup')) ||
        this.service.service === 'badges'
      ) {
        this.service.type = 'solo';
      } else {
        this.service.type = 'duo';
      }
    }

    if (this.service.hasOwnProperty('streaming')) {
      this.isWithStreaming = this.service.streaming;
    }

    if (this.service.hasOwnProperty('voice')) {
      this.isWithVoice = this.service.voice;
    }

    this.updatePrice();

    // tslint:disable-next-line:max-line-length
    const rankName = DivisionsService.getRankByValue((this.service.service === 'divisions' || this.service.service === 'doubleup') ? this.service.desired : this.service.current, this.service.game);
    this.rankName = this.service.service === 'placements' && rankName
      ? rankName.split(' ')[0]
      : rankName;
    if (this.ratingResp) {
      this.calculateCustomerCount();
      this.calculateRating();
    }

    this.isSoloAvailable = services[service.game].find(serviceDefinition => serviceDefinition.service === service.service).isSoloAvailable;

    if (service.game === 'tft' && service.queue === 'doubleup') {
      this.isDuoAvailable = true;
    } else {
      this.isDuoAvailable = services[service.game].find(serviceDefinition => serviceDefinition.service === service.service).isDuoAvailable;
    }
  }
  @Input() allowChampions = true;
  @Input() customization: ServiceCustomization;
  @Input() campaign: string;
  @Input() lang: string;
  @Output() heightUpdated = new EventEmitter();
  @Output() typeChange = new EventEmitter<string>();
  @Output() expressChange = new EventEmitter<string>();
  @Output() soloOnlyChange = new EventEmitter<boolean>();
  @Output() streamingChange = new EventEmitter<boolean>();
  @Output() voiceChange = new EventEmitter<boolean>();

  public showPaymentMethods = false;
  public showCashappInstructions = false;
  public showAmazonPayment = false;
  public cashappOrderId = false;
  public isExpress: boolean;
  public serviceTitle: string;
  public title: string;
  public currentRank: string;
  public desiredRank: string;
  public service: Service;
  public serviceData;
  public currency: string = '';
  public servicePrice: number;
  public discountedServicePrice: number;
  public isDuoCookie;
  public price: number;
  public cashback: number;
  public discountedPrice: number = 0;
  public discount: string = '30';
  public oldPrice: number;
  public priceError: string;
  public discounts = [];
  public availableDiscounts = [];
  public credits = [];
  public customerCount;
  public rating;
  public rankName;
  public isSubmitting = false;
  public creditsAvailable = false;
  public country;
  public isBrowser = false;
  public amazonClientId: string;
  public amazonSellerId: string;
  public useAmazonSandbox: boolean;
  public amazonPayment = {
    paymentMethod: null,
    orderReferenceId: null
  };
  public username: string;
  public showCaptcha = new BehaviorSubject(false);
  public isCaptchaValid = new BehaviorSubject(false);
  public showEmailInput = false;
  public availablePaymentMethods = [];

  public isPriceLoading = false;
  private selectedCreditAmount = 0;
  private selectedDiscountAmount = 0;
  private selectedDiscountId = null;
  private ratingResp: any;
  private stripeHandler;

  public isDuoAvailable = false;
  public isSoloAvailable = false;
  public isWithCharacters = false;
  public isWithPaidCharacters = false;
  public isSummonerSpellsOn = false;
  public role;
  private destroyed = new Subject();
  public charactersTop = {
    default: {
      'lol-left': -232,
      'lol-right': -134,
      'valorant-left': -82,
      'valorant-right': -134,
      'tft-left': -150,
      'tft-right': -211,
      'wild-rift-left': -232,
      'wild-rift-right': -134,
      'cs2-left': -270,
      'cs2-right': -184,
      'apex-left': -186,
      'apex-right': -134,
      'marvel-left': -117,
      'marvel-right': -114
    },
    campaign: {
      'lol-left': -232,
      'lol-right': -134,
      'valorant-left': -82,
      'valorant-right': -134,
      'tft-left': -150,
      'tft-right': -134,
      'wild-rift-left': -232,
      'wild-rift-right': -134,
      'cs2-left': -226,
      'cs2-right': -184,
      'apex-left': -186,
      'apex-right': -134
    }
  }

  private ballGame = '';
  public cdnUrl = 'https://cdn.ggboost.com/images';

  isRolesCustomizationOn: boolean = false;
  isSoloOnly: boolean = false;
  isWithStreaming: boolean = false;
  isWithVoice: boolean = false;

  private defaultPrimaryPosition: string = '';
  private defaultSecondaryPosition: string = '';

  private urlLangPrefix: string = '';

  extraServiceCharactersTax: number = 10;
  extraServiceSoloOnlyTax: number = 20;
  extraServiceStreamingTax: number = 15;
  extraServiceVoiceTax: number = 10;

  subtotal: number = 0;

  @HostListener('document:click', ['$event.target']) onClick(event) {
    // this.showPaymentMethods = false;
    // this.showCashappInstructions = false;
    // this.showAmazonPayment = false;
    // this.showEmailInput = false;
  }

  constructor(
    private http: HttpClient,
    private userService: UserService,
    private priceCalculator: PriceService,
    /*private reviewService: ReviewService,*/
    private cookie: CookieService,
    private snotify: ToastrService,
    @Inject(PLATFORM_ID) platformId: string,
    private modalService: NgxEzModalService,
    private resolver: ComponentFactoryResolver,
    private gtmService: GoogleTagManagerService,
    private router: Router,
    private cdRef: ChangeDetectorRef
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit() {
    this.amazonClientId = environment.amazonClientId;
    this.amazonSellerId = environment.amazonSellerId;
    this.useAmazonSandbox = environment.useAmazonSandbox;
    this.http.get('/auth/country').subscribe((country: any) => {
      this.country = country.countryCode;
    });
    this.userService.getUser().subscribe((user: any) => {
      if (user) {
        this.username = user.nickname;
        this.role = user.role;
        this.http.get('/customer/profile/spendable').subscribe((resp: any) => {
          if (resp) {
            this.discounts = resp.discounts;
            this.credits = resp.credits;
            this.availableDiscounts = this.getAvailableDiscounts(this.discounts, this.service);
            this.heightUpdated.emit();
          }
        });
      }
    });

    if (!this.defaultPrimaryPosition) {
      if (this.service.game === 'valorant' || this.service.game === 'apex' || this.service.game === 'marvel') {
        this.customization.primaryPosition = 'fill';
        this.customization.secondaryPosition = 'fill';
      }
      this.defaultPrimaryPosition = this.customization.primaryPosition;
      this.defaultSecondaryPosition = this.customization.secondaryPosition;
    }

    if (this.lang !== 'en') {
      this.urlLangPrefix = '/' + this.lang;
    }

    this.http.get('/prices/extra-services').subscribe((resp: any) => {
      if (resp) {
        this.extraServiceCharactersTax = Math.round(resp.characters ? (resp.characters -1) * 100 : 10);
        this.extraServiceSoloOnlyTax = Math.round(resp.soloOnly ? (resp.soloOnly -1) * 100 : 20);
        this.extraServiceStreamingTax = Math.round(resp.streaming ? (resp.streaming -1) * 100 : 15);
        this.extraServiceVoiceTax = Math.round(resp.voice ? (resp.voice -1) * 100 : 10);
        this.cdRef.detectChanges();
      }
    });


    /*this.reviewService.getRatios().subscribe((resp: any) => {
    this.ratingResp = resp;

    this.calculateRating();
    this.calculateCustomerCount();
    });*/
  }

  async reportConversionBuyBoost(orderToken: string) {
    const gtmTag = {
      event: 'buyBoostButton',
      send_to: 'AW-693423887/QbfQCL6j7pUYEI-e08oC',

    };

    this.gtmService.pushTag(gtmTag);
    setTimeout(() => {
      window.location.href = this.urlLangPrefix + `/buy-authenticate/${orderToken}`;
    }, 1500);
  }

  resolved(captchaResponse: string) {
    if (captchaResponse) {
      this.isCaptchaValid.next(true);
    } else {
      this.isCaptchaValid.next(false);
    }
  }

  isCreditsAvailable() {
    if (this.credits) {
      return this.credits.some(credit => this.currency.toLowerCase() === credit.currency.toLowerCase() && credit.amount > 0);
    }

    return false;
  }

  calculateRating() {
    let rating;

    let value = 0;
    if (this.service.service === 'masteries') {
      value = this.service.desired - 1;
    } else if (this.service.service === 'leveling') {
      value = 0;
    } else {
      value = this.service.current;
    }

    if (this.service.service === 'normalgames') {
      if (this.service.game === 'tft') {
        rating = this.ratingResp.tftSoloNormalgames.rates;
      } else if (this.service.game === 'valorant') {
        rating = this.ratingResp.valorantSoloNormalgames.rates;
      } else if (this.service.game === 'wild-rift') {
        rating = this.ratingResp.wildRiftSoloNormalgames.rates;
      } else {
        rating = this.ratingResp.soloNormalgames.rates;
      }
    } else {
      if (this.service.game === 'tft') {
        rating = (this.ratingResp[
          'tft' + this.capitalizeFirstLetter(this.service.type) + this.capitalizeFirstLetter(this.service.service)
        ] || { rates: {} }).rates[value];
      } else if (this.service.game === 'valorant') {
        rating = (this.ratingResp[
          'valorant' + this.capitalizeFirstLetter(this.service.type) + this.capitalizeFirstLetter(this.service.service)
        ] || { rates: {} }).rates[value];
      } else if (this.service.game === 'wild-rift') {
        rating = (this.ratingResp[
          'wildRift' + this.capitalizeFirstLetter(this.service.type) + this.capitalizeFirstLetter(this.service.service)
        ] || { rates: {} }).rates[value];
      } else {
        rating = (this.ratingResp[this.service.type + this.capitalizeFirstLetter(this.service.service)] || { rates: {} }).rates[value];
      }
    }

    this.rating = rating;
  }

  calculateCustomerCount() {
    let customerCount;
    let value = this.service.current;
    if (this.service.service === 'divisions') {
      value = this.service.desired;
    }
    if (this.service.service === 'masteries') {
      value = this.service.desired - 1;
    }
    if (this.service.service === 'leveling') {
      value = 0;
    }
    if (this.service.service !== 'divisions' && this.service.service !== 'masteries' && this.service.service !== 'leveling') {
      value = this.service.current;
    }

    if (this.service.service === 'normalgames') {
      if (this.service.game === 'tft') {
        customerCount = this.ratingResp.tftSoloNormalgames.customers;
      } else if (this.service.game === 'valorant') {
        customerCount = this.ratingResp.valorantSoloNormalgames.customers;
      } else if (this.service.game === 'wild-rift') {
        customerCount = this.ratingResp.wildRiftSoloNormalgames.customers;
      } else {
        customerCount = this.ratingResp.soloNormalgames.customers;
      }
    } else {
      if (this.service.game === 'tft') {
        // tslint:disable-next-line:max-line-length
        customerCount = (this.ratingResp['tft' + this.capitalizeFirstLetter(this.service.type) + this.capitalizeFirstLetter(this.service.service)] || { customers: {} }).customers[value];
      } else if (this.service.game === 'valorant') {
        // tslint:disable-next-line:max-line-length
        customerCount = (this.ratingResp['valorant' + this.capitalizeFirstLetter(this.service.type) + this.capitalizeFirstLetter(this.service.service)] || { customers: {} }).customers[value];
      } else if (this.service.game === 'wild-rift') {
        // tslint:disable-next-line:max-line-length
        customerCount = (this.ratingResp['wildRift' + this.capitalizeFirstLetter(this.service.type) + this.capitalizeFirstLetter(this.service.service)] || { customers: {} }).customers[value];
      } else {
        // tslint:disable-next-line:max-line-length
        customerCount = (this.ratingResp[this.service.type + this.capitalizeFirstLetter(this.service.service)] || { customers: {} }).customers[value];
      }
    }

    this.customerCount = customerCount;
  }

  capitalizeFirstLetter(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  onSelectCredits(event, currency) {
    if (event.target.checked) {
      this.selectedCreditAmount = this.credits.find(c => c.currency === currency).amount;
    } else {
      this.selectedCreditAmount = 0;
    }

    this.updatePrice();
  }

  onSelectDiscount(event, id) {
    if (event.target.checked) {
      const selectedDiscount = this.discounts.find(d => d.id === id);
      if (selectedDiscount) {
        this.selectedDiscountAmount = selectedDiscount.amount;
        this.selectedDiscountId = selectedDiscount.id;
      }
    } else {
      this.selectedDiscountAmount = 0;
      this.selectedDiscountId = null;
    }

    this.availableDiscounts = this.getAvailableDiscounts(this.discounts, this.service, this.selectedDiscountId);
    this.updatePrice();

    this.heightUpdated.emit();
  }

  onToggleExpress() {
    this.isExpress = !this.isExpress;

    if (this.isExpress) {
      this.expressChange.emit('1');
    } else {
      this.expressChange.emit('0');
    }

    this.updatePrice();
  }

  // onAmazonPurchase() {
  //   const data = {
  //     ...this.generatePurchaseData(),
  //     paymentMethod: 'amazon',
  //     amazonData: this.amazonPayment
  //   };
  //   this.isSubmitting = true;

  //   this.http.post('/payment-gateway/purchase', data).subscribe((resp: any) => {
  //     if (resp.success) {
  //       window.location.href = resp.url;
  //     } else {
  //       this.snotify.error(resp.error);
  //     }
  //     this.isSubmitting = false;
  //   });
  // }

  // async onPurchase(
  //   method: 'paypal' | 'stripe' | 'credit' | 'cashapp' | 'amazon' | 'payop' | 'paymentwall',
  //   event: MouseEvent,
  //   email?: string
  // ) {
  //   const user = await this.userService.getUser().pipe(take(1)).toPromise();

  //   if (method === 'stripe') {
  //     const data = {...this.generatePurchaseData(), paymentMethod: 'stripe', email};

  //     this.showEmailInput = false;
  //     this.isSubmitting = true;
  //     this.showPaymentMethods = false;

  //     this.http.post('/payment-gateway/purchase', data).subscribe((resp: any) => {
  //       if (resp.success) {
  //         const stripe = (window as any).Stripe(environment.stripeKey);
  //         stripe.redirectToCheckout({sessionId: resp.url});
  //       } else {
  //         this.isSubmitting = false;
  //         this.snotify.error(resp.error);
  //       }
  //     });

  //     // this.stripeHandler.open({
  //     //   locale: 'auto',
  //     //   name: 'Powered by Stripe',
  //     //   image: 'https://cdn.ggboost.com/images/logo-blue.png',
  //     //   amount: Math.round(this.discountedPrice * 100),
  //     //   currency: this.currency.toUpperCase()
  //     // });
  //   } else if (method === 'amazon') {
  //     event.stopPropagation();
  //     this.showPaymentMethods = false;
  //     this.showAmazonPayment = true;
  //   } else if (method === 'paymentwall' && !email && !user) {
  //     event.stopPropagation();
  //     this.showPaymentMethods = false;
  //     this.showEmailInput = true;
  //   } else {
  //     if (method === 'cashapp') {
  //       event.stopPropagation();
  //       if (!this.isCaptchaValid.value) {
  //         this.showCaptcha.next(true);
  //         await this.isCaptchaValid.pipe(filter(e => e), take(1)).toPromise();
  //         this.showCaptcha.next(false);
  //       }
  //     }

  //     this.showPaymentMethods = false;
  //     const data = {...this.generatePurchaseData(), paymentMethod: method, email};

  //     this.showEmailInput = false;
  //     this.isSubmitting = true;

  //     this.http.post('/payment-gateway/purchase', data).subscribe((resp: any) => {
  //       if (resp.success) {
  //         if (method === 'cashapp') {
  //           this.isSubmitting = false;
  //           this.showCashappInstructions = true;
  //           this.cashappOrderId = resp.url;
  //         } else {
  //           window.location.href = resp.url;
  //         }
  //       } else {
  //         this.isSubmitting = false;
  //         this.snotify.error(resp.error);
  //       }
  //     });
  //   }
  // }

  buyBoost(event: MouseEvent) {
    const delay = ms => new Promise(res => setTimeout(res, ms));

    event.preventDefault();
    event.stopPropagation();


    this.isPriceLoading = true;
    this.isSubmitting = true;

    const url = '/payment-gateway/pre-purchase';

    // if the discountedPrice is 0, we try to do the purchase with customer credits
    /*if (this.discountedPrice === 0) {
      method = 'credit';
      url = '/payment-gateway/purchase';
    }*/

    // get full data for the current order
    const oc: string = this.cookie.get('oc');
    let reS: string = this.cookie.get('re-s');

    const data = {
      ...this.generatePurchaseData(),
      oc: (oc && oc === '1' ? true : false),
      re: this.cookie.get('re'),
      reS: this.cookie.get('re-s'),
      sd: this.cookie.get('sd'),
    };

    // remove null or undefined keys
    Object.keys(this.serviceData).forEach(key => {
      if (this.serviceData[key] === undefined || this.serviceData[key] === null) {
        delete this.serviceData[key];
      }
    });

    this.http.post(url, data).subscribe(async (resp: any) => {
      if (resp.success) {
        //window.location.href = `/buy-authenticate/${resp.orderToken}`;
        this.reportConversionBuyBoost(resp.orderToken);
      } else {
        this.isSubmitting = false;
        this.isPriceLoading = false;
        this.snotify.error(resp.error);
      }
    }, (error) => { // Error callback
      console.error('Error occurred during the HTTP request:', error);
      this.isSubmitting = false;
      this.isPriceLoading = false;
      this.snotify.error('An error occurred while processing your purchase. Please try again.');
    }
    );

  }

  // onShowPaymentMethods(event: MouseEvent) {
  //   event.preventDefault();
  //   event.stopPropagation();

  //   if (this.discountedPrice === 0) {
  //     this.onPurchase('credit', event);
  //     return;
  //   }

  //   if (this.availablePaymentMethods.length === 1) {
  //     this.onPurchase(this.availablePaymentMethods[0].type, event);
  //     return;
  //   }

  //   this.showEmailInput = false;
  //   this.showAmazonPayment = false;
  //   this.showCashappInstructions = false;
  //   this.showPaymentMethods = true;
  // }

  private async updatePrice() {
    try {
      if (!this.isBrowser) {
        return;
      }

      this.isPriceLoading = true;
      this.priceError = null;
      const newCurrency = this.service.server === 'euw' || this.service.server === 'eune' || this.service.server === 'eu' || this.service.server === 'europe' || this.service.server === 'me' ? 'eur' : 'usd';

      if (newCurrency !== this.currency) {
        this.currency = newCurrency;
        /*this.fetchAvailablePaymentMethods(this.currency);*/
      }

      const totalPriceObj = await this.priceCalculator.getServicePrice({
        ...this.service,
        currency: this.currency,
        creditCurrency: this.currency,
        credits: this.selectedCreditAmount,
        discountAmount: this.selectedDiscountAmount,
        isExpress: this.isExpress,
        isSoloOnly: this.isSoloOnly,
        isWithStreaming: this.isWithStreaming,
        isWithCharacters: this.isWithCharacters,
        isWithPaidCharacters: this.isWithPaidCharacters,
        isWithVoice: this.isWithVoice
      });

      if (!this.cookie.check('sd')) {
        this.cookie.set('sd', totalPriceObj.sd, 3560, '/', (environment.production ? '.ggboost.com' : 'localhost'));
      }

      this.discountedPrice = totalPriceObj.discountedPrice;
      this.discount = (totalPriceObj.campaignDiscount * 100).toFixed(0);
      this.subtotal = this.discountedPrice / (1 - totalPriceObj.campaignDiscount);

      this.price = totalPriceObj.price;
      this.cashback = totalPriceObj.cashback;
      this.oldPrice = totalPriceObj.oldPrice;
      this.isPriceLoading = false;

    } catch (e) {
      this.priceError = e.message;
      this.isPriceLoading = false;
    }
    this.cdRef.detectChanges();
  }

  private getAvailableDiscounts(discounts: any[], service: Service, selectedDiscountId?: number) {
    if (!discounts || !discounts.length) {
      return [];
    }

    return discounts.filter(el => {
      if (el.sku === 'global') {
        return true;
      }
    }).filter(discount => {
      if (selectedDiscountId) {
        return discount.id === selectedDiscountId;
      }

      return true;
    });
  }

  private generateTitle(service: Service) {
    let title = '';

    if (service.game === 'valorant' || service.game === 'marvel') {
      this.ballGame = '-' + service.game;
    }

    if (service.service === 'badges') {
      let badgeName = DivisionsService.getBadgeTitle(service.badge, service.game);
      title = '<span class="dot unranked"></span> ' + badgeName + ' - ' + service.champion;
    }

    if (service.service === 'divisions' || service.service === 'doubleup') {
      this.currentRank = DivisionsService.getRankByValue(service.current, service.game);
      if (service.game === 'cs2') {//
        title = '<span class="dot" style="background:' + cs2RanksToColor(service.current) + '"></span> ' + (parseInt(this.currentRank) + service.lp);
      }
      else {
        title = '<span class="dot ' + this.currentRank.split(' ')[0].toLowerCase() + this.ballGame + '"></span> ' + this.currentRank;
      }

      this.desiredRank = DivisionsService.getRankByValue(service.desired, service.game);
      if (service.game === 'cs2') {
        title += ' <span class="arrow">→</span> ' + '<span class="dot" style="background:' + cs2RanksToColor(service.desired) + '"></span> ';
      }
      else {
        title += ' <span class="arrow">→</span> ' + '<span class="dot ' + this.desiredRank.split(' ')[0].toLowerCase() + this.ballGame + '"></span> ';
      }
      title += this.desiredRank;
    }

    if (service.service === 'placements') {

      if ((service.game === 'lol' || service.game === 'tft' || service.game === 'wild-rift') &&
        (service.current >= DivisionsService.getValueByRank('Diamond IV', service.game) &&
          service.current <= DivisionsService.getValueByRank('Diamond I', service.game))) {
        this.currentRank = DivisionsService.getRankByValue(service.current, service.game);
      } else if (service.game === 'valorant') {
        this.currentRank = DivisionsService.getDivisionNameByValue(service.current, service.game);
      } else if (service.game === 'cs2') {
        this.currentRank = 'Unranked'
      } else {
        this.currentRank = DivisionsService.getDivisionNameByValue(service.current, service.game);
      }
      title = '<span class="dot ' + this.currentRank.split(' ')[0].toLowerCase() + this.ballGame + '"></span> ' + this.currentRank;

      title += ' <span class="arrow">→</span> ' + service.desired + ' ' + ((service.game === 'apex' ? 'Provisional' : 'Placement')) + ' ' + (service.game === 'cs2' ? 'Wins' : 'Games');
    }

    if (service.service === 'netwins') {
      this.currentRank = DivisionsService.getRankByValue(service.current, service.game);

      if (service.game === 'cs2') {//
        title = '<span class="dot" style="background:' + cs2RanksToColor(service.current) + '"></span> ' + (parseInt(this.currentRank) + service.lp) +
          ' <span class="arrow">→</span> ' + service.desired + ' Net Wins';
      } else {
        title = '<span class="dot ' + this.currentRank.split(' ')[0].toLowerCase() + this.ballGame + '"></span> ' + this.currentRank +
          ' <span class="arrow">→</span> ' + service.desired + ' Net Wins';
      }

    }

    if (service.service === 'games') {
      this.currentRank = DivisionsService.getRankByValue(service.current, service.game);
      title = '<span class="dot ' + this.currentRank.split(' ')[0].toLowerCase() + this.ballGame + '"></span> ' + this.currentRank +
        ' <span class="arrow">→</span> ' + service.desired + ' Games';
    }

    if(service.service === 'normalgames') {
      title = '<span class="dot unranked"></span> ' + service.desired;

      if (service.game === 'valorant') {
        title += ' Unrated Wins';
      } else if (service.game === 'marvel') {
        title += ' Quick Wins';
      } else if (service.game === 'apex') {
        title += ' Unranked Wins';
      } else {
        title += ' Normal Wins';
      }
    }

    if (service.service === 'masteries' && service.game === 'lol') {
      title = '<span class="dot ' + this.getRankColorByMastery(service.current) + '"></span> ' + DivisionsService.getMasteryName(service.current, service.game) + ' <span class="arrow">→</span> ' +
        '<span class="dot ' + this.getRankColorByMastery(service.desired) + '"></span> ' + DivisionsService.getMasteryName(service.desired, service.game);
    }

    if (service.service === 'masteries' && service.queue === 'competitive') {
      const nameCurrent = this.shortenFirstName(DivisionsService.getMasteryName(service.current, service.game));
      const nameDesired = this.shortenFirstName(DivisionsService.getMasteryName(service.desired, service.game));
      title = '<img src="https://cdn.ggboost.com/images/ranks/cs2/competitive/' + service.current + '.webp" class="small-display" alt="cs2 ' + nameCurrent + '"> ' + nameCurrent + ' <span class="arrow">→</span> ' +
        '<img src="https://cdn.ggboost.com/images/ranks/cs2/competitive/' + service.desired + '.webp" class="small-display" alt="cs2 ' + nameDesired + '"> ' + nameDesired;
    }

    if (service.service === 'leveling') {
      title = '<span class="dot unranked"></span> ' + `Level ${service.current} → ` + '<span class="dot unranked"></span> ' + ` Level ${service.desired}`;
    }

    return title;
  }

  shortenFirstName(input: string): string {
    // Split the input by spaces to extract words
    const words = input.split(' ');

    // If the first word is longer than 3 characters, shorten it
    if (words.length > 3 || input.length > 21) {
      words[0] = words[0].charAt(0) + '.';
    }

    // Join the words back together into a single string
    return words.join(' ');
  }

  getRankColorByMastery(mastery) {
    if (mastery === 0) {
      return 'silver';
    }
    if (mastery >= 1 && mastery <= 4) {
      return 'gold';
    }
    if (mastery >= 5 && mastery <= 6) {
      return 'mastery5';
    }
    if (mastery >= 7 && mastery <= 9) {
      return 'mastery6';
    }
    if (mastery === 10) {
      return 'mastery7';
    }
  }

  private generateServiceTitle(service: Service) {
    let serviceTitle = service.type.toUpperCase();
    if (service.service === 'divisions') {
      if (service.game === 'valorant' || service.game === 'apex') {
        serviceTitle += ' Rank Boost';
      } else if (service.game === 'cs2' && service.queue === 'premier') {
        serviceTitle += ' Premier Boost';
      } else if (service.game === 'marvel') {
        serviceTitle += ' Competitive Boost';
      } else {
        serviceTitle += ' Division Boost';
      }
    }
    if (service.service === 'placements') {
      if (service.game === 'apex') {
        serviceTitle += ' Provisional Boost';
      } else {
        serviceTitle += ' Placement Boost';
      }
    }
    if (service.service === 'netwins') {
      serviceTitle += ' Net Wins';
    }
    if (service.service === 'badges') {
      serviceTitle += ' Badge Boosting';
    }
    if (service.service === 'games') {
      serviceTitle += ' Games';
    }
    if (service.service === 'normalgames') {
      if (service.game === 'lol' || service.game === 'tft' || service.game === 'wild-rift' ) {
        serviceTitle += ' Normal Wins';
      }
      if (service.game === 'valorant') {
        serviceTitle += ' Unrated Wins';
      }
      if (service.game === 'apex') {
        serviceTitle += ' Unranked Wins';
      }
      if (service.game === 'marvel') {
        serviceTitle += ' Quick Wins';
      }
    }
    if (service.service === 'masteries') {
      if (service.game === 'lol') {
        serviceTitle += ` Masteries (${service.champion})`;
      } else if (service.game === 'cs2') {
        serviceTitle += ' Competitive Boost';
      }

    }
    if (service.service === 'leveling') {
      serviceTitle += ` Leveling`;
    }
    if (service.service === 'doubleup') {
      serviceTitle += ` Double Up Boost`;
    }

    return serviceTitle;
  }

  private generatePurchaseData() {
    const data: any = {};
    this.serviceData = {};

    this.serviceData.role = this.role;

    this.serviceData.game = this.service.game;
    data.game = this.service.game;
    data.server = this.service.game === 'wild-rift' && this.service.server === 'eu' ? 'euw' : this.service.server;

    this.serviceData.type = this.service.type;
    data.type = this.service.type;

    this.serviceData.queue = this.service.queue;
    data.queue = this.service.queue;

    this.serviceData.platform = this.service.platform;
    data.platform = this.service.platform;

    this.serviceData.service = this.service.service;
    data.service = this.service.service;

    data.currency = this.service.server === 'euw' || this.service.server === 'eune' || this.service.server === 'eu' || this.service.server === 'europe' || this.service.server === 'me' ? 'eur' : 'usd';

    this.serviceData.isExpress = this.service.isExpress;
    data.isExpress = this.isExpress;

    data.isSoloOnly = this.isSoloOnly;
    data.isWithStreaming = this.isWithStreaming;
    data.isWithVoice = this.isWithVoice;

    this.serviceData.champion = this.service.champion;
    data.champion = this.service.champion;

    if (data.service === 'divisions' || data.service === 'doubleup') {
      data.startingRank = this.service.current;
      data.desiredRank = this.service.desired;
      data.startingPromos = this.service.promos;
      data.startingLp = this.service.lp;
      this.serviceData.startingRank = this.service.current;
      this.serviceData.desiredRank = this.service.desired;
      this.serviceData.startingPromos = this.service.promos;
      this.serviceData.startingLp = this.service.lp;
    }

    if (data.service === 'masteries') {
      data.startingRank = this.service.current;
      data.desiredRank = this.service.desired;
      this.serviceData.startingRank = this.service.current;
      this.serviceData.desiredRank = this.service.desired;
    }

    if (data.service === 'leveling') {
      data.startingRank = this.service.current;
      data.desiredRank = this.service.desired;
      this.serviceData.startingRank = this.service.current;
      this.serviceData.desiredRank = this.service.desired;
    }

    if (data.service === 'netwins') {
      data.startingRank = this.service.current;
      data.desiredWins = this.service.desired;
      this.serviceData.startingRank = this.service.current;
      this.serviceData.desiredWins = this.service.desired;
      if (this.service.game === 'cs2') {
        this.serviceData.startingLp = this.service.lp;
        data.startingLp = this.service.lp;
      }
    }

    if (data.service === 'badges') {
      data.desiredRank = this.service.badge;
    }

    if (data.service === 'games' || data.service === 'placements') {
      data.startingRank = this.service.current;
      data.desiredGames = this.service.desired;
      this.serviceData.startingRank = this.service.current;
      this.serviceData.desiredGames = this.service.desired;
      if (this.service.game === 'cs2') {
        this.serviceData.startingLp = this.service.lp;
        data.startingLp = this.service.lp;
      }
    }

    if (data.service === 'normalgames') {
      data.desiredWins = this.service.desired;
      this.serviceData.desiredWins = this.service.desired;
    }

    data.consumeCredits = this.selectedCreditAmount;
    this.serviceData.consumeCredits = this.selectedCreditAmount;
    data.selectedDiscount = this.selectedDiscountId;

    if (this.isWithCharacters) {
      data.characters = this.customization.characters;
      data.isWithCharacters = true;
      data.isWithPaidCharacters = this.isWithPaidCharacters;
    } else {
      data.characters = [];
      data.isWithCharacters = false;
      data.isWithPaidCharacters = false;
    }

    if (this.isRolesCustomizationOn) {
      data.primaryPosition = this.customization.primaryPosition;
      data.secondaryPosition = this.customization.secondaryPosition;
      data.keySet = this.customization.keySet;
    } else {
      data.primaryPosition = 'fill';
      data.secondaryPosition = 'fill';
      data.keySet = 1;
    }

    if (this.service.platform !== 'pc') {
      data.isWithStreaming = false;
    }

    if (this.service.game === 'wild-rift') {
      data.isWithStreaming = false;
      data.isWithVoice = false;
    }


    // data.paymentMethod = this.paymentMethod.toLowerCase();

    return data;
  }

  selectSolo(isSoloAvailable) {
    if (!isSoloAvailable) {
      return;
    }
    if (this.service.type === 'solo') {
      return;
    } else {
      this.typeChange.emit('solo');
      this.cookie.set('gg-type', 'solo', 3650, '/');

      this.isWithCharacters = false;
      this.isWithPaidCharacters = false;
      this.customization.characters = [];

      this.isSoloOnly = false;
    }
  }

  selectDuo(isDuoAvailable) {
    if (!isDuoAvailable) {
      return;
    }

    if (this.service.type === 'duo') {
      return;
    } else if (!this.isDuoAvailable) {
      return;
    } else {
      this.typeChange.emit('duo');
      this.cookie.set('gg-type', 'duo', 3650, '/');

      this.isWithCharacters = false;
      this.isWithPaidCharacters = false;
      this.customization.characters = [];

      this.isSoloOnly = false;
    }
  }

  onToggleDuo() {
    if (this.service.type === 'duo') {
      this.typeChange.emit('solo');
      this.cookie.set('gg-type', 'solo', 3650, '/');
    } else {
      this.typeChange.emit('duo');
      this.cookie.set('gg-type', 'duo', 3650, '/');
    }

    this.isWithCharacters = false;
    this.isWithPaidCharacters = false;
    this.customization.characters = [];
  }

  isDuo() {
    if (this.cookie.check('gg-type')) {
      if (this.cookie.get('gg-type') === 'duo') {
        return true;
      } else {
        return false;
      }
    } else {
      return this.service.type === 'duo';
    }
  }

  onToggleCustomization() {
    this.isWithCharacters = !this.isWithCharacters;

    if (this.isWithCharacters) {
      if (this.service.game === 'tft') {
        return;
      } else if (this.service.game === 'wild-rift') {
        this.showLolCustomization('wild-rift');
        return;
      } else if (this.service.game === 'valorant') {
        this.showValorantCustomization();
        return;
      } else if (this.service.game === 'lol') {
        this.showLolCustomization('lol');
        return;
      } else if (this.service.game === 'apex' || this.service.game === 'marvel') {
        // this.showApexCustomization();
        this.showGameCharacterSelect();
        return;
      }
    } else {
      this.customization = {
        ...this.customization,
        characters: []
      }
      this.isWithPaidCharacters = false;
    }
    this.updatePrice();
  }

  toggleRolesCustomization() {
    this.isRolesCustomizationOn = !this.isRolesCustomizationOn;

    if (this.isRolesCustomizationOn) {
      if (this.service.game === 'tft') {
        return;
      } else {
        this.showRolesCustomization();
        return;
      }
    } else {
      this.customization = {
        ...this.customization,
        primaryPosition: '',
        secondaryPosition: '',
        keySet: 1
      }
    }
  }

  toggleSoloOnly() {
    this.isSoloOnly = !this.isSoloOnly;

    if (this.isExpress) {
      this.soloOnlyChange.emit(true);
    } else {
      this.soloOnlyChange.emit(false);
    }

    this.updatePrice();
  }

  toggleStreaming() {
    this.isWithStreaming = !this.isWithStreaming;

    if (this.isWithStreaming) {
      this.streamingChange.emit(true);
    } else {
      this.streamingChange.emit(false);
    }

    this.updatePrice();
  }

  toggleVoice() {
    this.isWithVoice = !this.isWithVoice;

    if (this.isWithVoice) {
      this.voiceChange.emit(true);
    } else {
      this.voiceChange.emit(false);
    }

    this.updatePrice();
  }

  private showRolesCustomization() {
    const modal = this.modalService.open('rolesCustomization', PositionSelectComponent, false, { width: '600px', closeOnOutsideClick: false }) as PositionSelectComponent;
    modal.lang = this.lang;
    modal.selectedPrimaryRole = this.customization.primaryPosition || this.defaultPrimaryPosition ;
    modal.selectedSecondaryRole = this.customization.secondaryPosition || this.defaultSecondaryPosition;
    modal.keySet = this.customization.keySet;
    modal.game = this.service.game;
    modal.type = this.service.type;

    modal.selectedData.pipe(take(1), takeUntil(this.destroyed)).subscribe(() => {
      this.customization = {
        ...this.customization,
        primaryPosition: modal.selectedPrimaryRole,
        secondaryPosition: modal.selectedSecondaryRole,
        keySet: modal.keySet
      };
    });
  }

  private showLolCustomization(game: string) {
    const instance = this.modalService.open('customization', LolCustomizationModalComponent, false, {
      width: '1200px',
      closeOnOutsideClick: false
    }, this.resolver) as LolCustomizationModalComponent;

    instance.currentSelectedChampions = this.customization.characters;
    instance.game = game;
    instance.type = this.service.type;
    instance.extraServiceCharactersTax = this.extraServiceCharactersTax;

    instance.lang = this.lang;
    instance.selected.pipe(take(1), takeUntil(this.destroyed)).subscribe(() => {
      const characters = instance.currentSelectedChampions;
      if (characters.length > 0) {
        this.customization = {
          ...this.customization,
          characters: characters,
        }
        this.isWithPaidCharacters = (game === 'lol' && this.service.type === 'solo' && characters.length >= 1 && characters.length <= 3 ? true : false);
      } else {
        this.isWithCharacters = false;
        this.isWithPaidCharacters = false;
        this.customization.characters = [];
      }
      this.updatePrice();
    });
  }

  private showValorantCustomization() {
    const instance = this.modalService.open('customization', ValorantCustomizationModalComponent, false, {
      width: '500px',
      closeOnOutsideClick: false
    }, this.resolver) as ValorantCustomizationModalComponent;

    instance.currentSelectedChampions = this.customization.characters;
    instance.lang = this.lang;

    instance.selected.pipe(take(1), takeUntil(this.destroyed)).subscribe(() => {
      const characters = instance.currentSelectedChampions;

      if (characters.length > 0) {
        this.customization = {
          ...this.customization,
          characters: characters,
        }
      } else {
        this.isWithCharacters = false;
        this.customization.characters = [];
      }
      this.updatePrice();
    });
  }

  private showGameCharacterSelect() {
    let width = '600px';

    if (this.service.game === 'marvel') {
      width = '900px';
    }

    const characterSelector = this.modalService.open(
      'characterSelect',
      GameCharacterSelectComponent,
      false,
      {width: width},
      this.resolver
    ) as GameCharacterSelectComponent;
    characterSelector.lang = this.lang;
    characterSelector.singleSelect = false;
    characterSelector.currentSelectedCharacters = this.customization.characters;
    characterSelector.game = this.service.game;

    characterSelector.selected.pipe(take(1), takeUntil(this.destroyed)).subscribe((champion: string) => {
      const characters = characterSelector.currentSelectedCharacters;

      if (characters.length > 0) {
        this.customization = {
          ...this.customization,
          characters: characters,
        }
      } else {
        this.isWithCharacters = false;
        this.customization.characters = [];
      }
      this.updatePrice();
    });
  }

  ngOnDestroy() {
    this.destroyed.next(1);
    this.destroyed.complete();
  }
}